export default __webpack_public_path__ + "static/media/6.b6e51653.png";